import { render, staticRenderFns } from "./componentReporter.vue?vue&type=template&id=5a235946&"
import script from "./componentReporter.vue?vue&type=script&lang=ts&"
export * from "./componentReporter.vue?vue&type=script&lang=ts&"
import style0 from "./componentReporter.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports